import { v4 as uuidv4 } from 'uuid';

export function TabLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'TabLayout',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
